import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "StringText"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21.75 16.5H18C17.6023 16.4995 17.2211 16.3413 16.9399 16.0601 16.6587 15.7789 16.5005 15.3977 16.5 15V10.5C16.5005 10.1023 16.6586 9.72105 16.9398 9.43984 17.221 9.15864 17.6023 9.00046 18 9H21.75V10.5H18V15H21.75V16.5zM13.5 9H10.5V6H9V16.5H13.5C13.8977 16.4995 14.2789 16.3413 14.5601 16.0601 14.8413 15.7789 14.9995 15.3977 15 15V10.5C14.9995 10.1023 14.8414 9.72105 14.5602 9.43984 14.279 9.15864 13.8977 9.00046 13.5 9zM10.5 15V10.5H13.5V15H10.5zM6 9H2.25V10.5H6V12H3C2.60218 12 2.22064 12.158 1.93934 12.4393 1.65804 12.7206 1.5 13.1022 1.5 13.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607 2.22064 16.342 2.60218 16.5 3 16.5H7.5V10.5C7.49954 10.1023 7.34136 9.72105 7.06016 9.43984 6.77895 9.15864 6.39768 9.00046 6 9zM6 15H3V13.5H6V15z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/StringText.vue"]]);
